import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

export default function VerticalFloatingDock({ items, side = "left" }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const isLeft = side === "left";

  return (
    <motion.div
      className="vf-dock"
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => {
        setIsHovered(false);
        setActiveIndex(null);
      }}
      animate={{
        scale: isHovered ? 1.06 : 1,
        padding: isHovered ? "11px 8px" : "8px 6px",
        boxShadow: isHovered
          ? "0 0 34px rgba(255, 255, 255, 0.22)"
          : "0 0 24px rgba(0, 0, 0, 0.35)",
        x: isHovered ? (isLeft ? 6 : -6) : 0,
      }}
      transition={{ type: "spring", stiffness: 300, damping: 22 }}
    >
      {items.map((item, index) => {
        const distance =
          activeIndex === null ? 0 : Math.abs(index - activeIndex);

        const scale =
          activeIndex === null ? 1 : Math.max(1.42 - distance * 0.14, 0.9);

        const x = activeIndex === index ? (isLeft ? 14 : -14) : 0;

        return (
          <motion.a
            key={item.title}
            href={item.href}
            target={item.href.startsWith("http") ? "_blank" : undefined}
            rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
            className={`vf-item ${isLeft ? "vf-left" : "vf-right"}`}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
            animate={{ scale, x }}
            transition={{ type: "spring", stiffness: 380, damping: 22 }}
            style={{ zIndex: activeIndex === index ? 20 : 1 }}
            aria-label={item.title}
          >
            {item.icon}

            <AnimatePresence>
              {activeIndex === index && (
                <motion.span
                  initial={{ opacity: 0, x: isLeft ? -8 : 8 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: isLeft ? -8 : 8 }}
                  transition={{ duration: 0.18 }}
                  className={`vf-label ${isLeft ? "vf-label-left" : "vf-label-right"}`}
                >
                  {item.title}
                </motion.span>
              )}
            </AnimatePresence>
          </motion.a>
        );
      })}
    </motion.div>
  );
}